import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, DataGridItem, DataGridItemsResponse, SetFiltersRequest, SchemaSVA } from '../types';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse } from '../../../../grid/types/common';

export class PackageSecurityServerAssignmentGridTableDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response: any;

  constructor(public dependencies: any, private data: Array<SchemaSVA>) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    return {
      summary: '',
      numItems: this.data.length,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<DataGridItemsResponse> {
    const currentPage: number = request.pageNumber as number;
    const pageSize: number = request.pageSize as number;
    const firstIndexFromPage: number = (currentPage - 1) * pageSize;

    const items: DataGridItem[] = this.data
      .slice(firstIndexFromPage, firstIndexFromPage + pageSize)
      .map((item: SchemaSVA, index: number) => {
        return { ...item, actions: '*', priority: firstIndexFromPage + index + 1 } as DataGridItem;
      });

    return { rawEvents: items, success: true };
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    return;
  }
}
